import { render, staticRenderFns } from "./InstallPWADialog.vue?vue&type=template&id=66294d58"
import script from "./InstallPWADialog.vue?vue&type=script&lang=ts"
export * from "./InstallPWADialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports